var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitchPpicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "url(#paint0_linear_91_7226)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_91_7226)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45312 4.125H13.875V9.5625L10.3594 13.058H8.79688L6.84375 15V13.058H4.5V6.06696L6.45312 4.125ZM13.0938 9.17411V4.90179H6.84375V10.7277H8.60156V12.0871L9.96875 10.7277H11.5312L13.0938 9.17411ZM11.9219 6.26116V8.59152H11.1406V6.26116H11.9219ZM9.77344 6.26116V8.59152H8.99219V6.26116H9.77344Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_91_7226",
    x1: 0,
    y1: 0,
    x2: 21.6987,
    y2: 9.86181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9146FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C8AF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_91_7226"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.375,
    height: 10.875,
    fill: "white",
    transform: "translate(4.5 4.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitchPpicIcon);
export default __webpack_public_path__ + "static/media/twitch-ppic-icon.715500fee3bccf4892ba69538463d8f1.svg";
export { ForwardRef as ReactComponent };